import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../constants/config";
import Preloader from "../Preloader";
import NetworkError from "../NetworkError";
import UserContext from "../../contexts/UserContext";
import LicenceClient from "./licencecli";




export default function LicencesClient({codelcient}) {
    // states
    const {user, logoutUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const [liceneList, setLicenceList] = useState([]);


    const getLicenceClientList = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses/${codelcient}?type=client`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setLicenceList(clientarray);

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
            
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }
    


    // comportements
    useEffect(() => {
        getLicenceClientList();
    }, []);


    // console.log("objet list: ", rulesobjectlist);

    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row">
                <div className="col-md-12 mb-3 pt-3 rounded" style={{borderTop: "1px solid #ccc"}}>
                    <div className="row">
                        {/* <div className="col-md-2 mb-3">  
                            <PaginationSelect table={"scan"} getList={getLicenceClientList} page={page} setPage={setPage} limit={100} current={currentpage} setCurrent={setCurrentpage} />
                        </div>
                        <div className="col-md-10 mb-3">
                            <Search 
                                chaine={chaine}
                                setChaine={setChaine}
                                search={searchScan}
                                placeholder="Search by access name..."
                            />
                            <Filterdate 
                                date={date}
                                setDate={setDate}
                                filterdate={filterByDate}
                                placeholder="Filter by date..."
                            />
                            <Filterselect 
                                list={list}
                                item={mode}
                                setItem={setMode}
                                filterselect={filterByMode}
                                placeholder="Filter by access types..."
                            />
                        </div> */}
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    <h6 className="m-0 ">Liste des licences du client</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive mb-3">
                                        <table className="mb-0 table table-bordered">
                                            <thead className="bg-primary">
                                                <tr className="bg-primary text-white">
                                                    <th className="text-center">#</th>
                                                    <th>Type de licence</th>
                                                    <th>Date début</th>
                                                    <th>Date fin</th>
                                                    <th>Etat</th>
                                                    <th>Date d'ajout</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(liceneList.length === 0) && <tr style={{borderStyle: "none"}}>
                                                    <th colSpan={7} className="text-center">Aucune licence trouvée pour ce client</th>
                                                </tr>}
                                                {
                                                    (liceneList.length > 0) && liceneList?.map((item, index) => (
                                                        <LicenceClient licence={item} position={index} key={index} />
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <Pagination table={"client"} getList={getLicenceClientList} page={page} setPage={setPage} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>} 
        </>
    )
    
}